type Props = {
  parentWidth?: number;
};

type TreeGraphContentType = {
  root?: TreeGraphContentType;
  depth: number;
  x: number;
  y: number;
  width: number;
  height: number;
  subName: string;
  color: string;
  index: number;
  name: string;
  children?: TreeGraphContentType[];
} & Props;

const TreeGraphContent = (props: Props) => {
  const { root, depth, subName, parentWidth, color, index, name, children } =
    props as TreeGraphContentType;

  if (depth === 1 || !root?.children) return null;

  const finalWidth = (parentWidth ?? 0) / root.children.length;
  const finalHeight = 60;

  return (
    <g>
      <rect
        x={finalWidth * index}
        y={finalHeight * root.index}
        width={finalWidth}
        height={finalHeight}
        className="stroke-none"
        stroke={color}
        fill={color}
      />
      <rect
        x={finalWidth * index}
        y={finalHeight * root.index}
        width={0.5}
        className="stroke-none"
        height={finalHeight}
        fill="white"
      />
      {!children ? (
        subName ? (
          <>
            <text
              x={finalWidth * index + finalWidth / 2}
              y={finalHeight * root.index + finalHeight / 2 - 2}
              textAnchor="middle"
              fontSize={12}
              fontWeight={100}
              // strokeOpacity={1}
              // strokeWidth={0.7}
            >
              {name}
            </text>
            <text
              x={finalWidth * index + finalWidth / 2}
              y={finalHeight * root.index + finalHeight / 2 + 14}
              textAnchor="middle"
              fontSize={12}
              fontWeight={50}
              // strokeOpacity={1}
              // strokeWidth={0.4}
            >
              {subName}
            </text>
          </>
        ) : (
          <text
            x={finalWidth * index + finalWidth / 2}
            y={finalHeight * root.index + finalHeight / 2}
            textAnchor="middle"
            fontSize={12}
            fontWeight={100}
            // strokeOpacity={1}
            // strokeWidth={0.7}
          >
            {name}
          </text>
        )
      ) : null}
    </g>
  );
};

export default TreeGraphContent;
